/**
 * Data layer for `kpi-threshold-triggers-cr-drop-epc-drop-fraud-spike-payout-b`. Thin typed fetch wrappers over /api/v1/kpi-threshold-triggers-cr-drop-epc-drop-fraud-spike-payout-b.
 * Raw `fetch()` is confined to this file per the dash contract.
 */

export interface KpiThresholdTriggersCrDropEpcDropFraudSpikePayoutBRow {
	id: string;
	tenant_id: string;
	created_at: number;
	updated_at: number;
	[key: string]: unknown;
}

export interface ListKpiThresholdTriggersCrDropEpcDropFraudSpikePayoutBResponse {
	count: number;
	items: KpiThresholdTriggersCrDropEpcDropFraudSpikePayoutBRow[];
}

export interface CreateKpiThresholdTriggersCrDropEpcDropFraudSpikePayoutBBody {
	[key: string]: unknown;
}

const BASE = "/api/v1/kpi-threshold-triggers-cr-drop-epc-drop-fraud-spike-payout-b";

async function parseOrThrow<T>(res: Response): Promise<T> {
	const text = await res.text();
	let data: unknown = null;
	if (text) {
		try {
			data = JSON.parse(text);
		} catch {
			data = text;
		}
	}
	if (!res.ok) {
		const msg =
			data &&
			typeof data === "object" &&
			data !== null &&
			"error" in data &&
			typeof (data as { error: unknown }).error === "string"
				? (data as { error: string }).error
				: `HTTP ${res.status}`;
		throw new Error(msg);
	}
	return data as T;
}

export async function list(): Promise<ListKpiThresholdTriggersCrDropEpcDropFraudSpikePayoutBResponse> {
	const res = await fetch(BASE, {
		method: "GET",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<ListKpiThresholdTriggersCrDropEpcDropFraudSpikePayoutBResponse>(res);
}

export async function create(body: CreateKpiThresholdTriggersCrDropEpcDropFraudSpikePayoutBBody): Promise<KpiThresholdTriggersCrDropEpcDropFraudSpikePayoutBRow> {
	const res = await fetch(BASE, {
		method: "POST",
		credentials: "include",
		headers: {
			accept: "application/json",
			"content-type": "application/json",
		},
		body: JSON.stringify(body ?? {}),
	});
	return parseOrThrow<KpiThresholdTriggersCrDropEpcDropFraudSpikePayoutBRow>(res);
}

export async function remove(id: string): Promise<{ removed: boolean }> {
	const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
		method: "DELETE",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<{ removed: boolean }>(res);
}

export const kpiThresholdTriggersCrDropEpcDropFraudSpikePayoutBQueryKeys = {
	all: ["kpi-threshold-triggers-cr-drop-epc-drop-fraud-spike-payout-b"] as const,
	list: () => [...kpiThresholdTriggersCrDropEpcDropFraudSpikePayoutBQueryKeys.all] as const,
	detail: (id: string) => [...kpiThresholdTriggersCrDropEpcDropFraudSpikePayoutBQueryKeys.all, id] as const,
};
